import { BUTTON_CLICK } from 'common-js/analytics/actionTypes';
import sendAnalyticsEvent from 'common-js/analytics/analytics';
import { ACTIVATION } from 'common-js/constants/paths';
import type { DeviceModel } from 'common-js/models';
import { setChangePlanDevices, setIsChangePlanFlag } from 'common-js/reducers/activation/actions';
import { getCachedDevices } from 'common-js/reducers/devices/selectors';
import { browserHistory } from 'react-router';
import ensureDevicesPersisted from './ensureDevicesPersisted';

const bulkDeviceChangePlan =
  (devices: Array<DeviceId>, page: string = 'SIM Inventory', orgId?: OrgId) =>
  async (dispatch, state) => {
    await dispatch(ensureDevicesPersisted(devices, orgId));

    const deviceIdsSet = new Set(devices);
    const cachedDevices: Record<number, DeviceModel> = getCachedDevices(state());

    if (!cachedDevices) {
      return;
    }

    const changePlanDevices: Array<DeviceModel> = [];
    Object.entries(cachedDevices).forEach(([deviceId, device]) => {
      if (deviceIdsSet.has(parseInt(deviceId, 10))) {
        changePlanDevices.push(device);
      }
    });

    if (changePlanDevices.length !== devices.length) {
      throw new Error(
        `Failed to get and persist all necessary devices. Found ${changePlanDevices.length} instead of ${devices.length}`
      );
    }

    dispatch(setIsChangePlanFlag());
    dispatch(setChangePlanDevices(changePlanDevices));

    browserHistory.push(ACTIVATION);
    sendAnalyticsEvent({
      type: BUTTON_CLICK,
      data: {
        name: `${page} - Change plan`,
      },
    });
  };

export default bulkDeviceChangePlan;
